const BASE_API_URL = "https://www.windpeak.net";
// const BASE_API_URL = "https://api.chifeng.io";

export { BASE_API_URL };

